import { render, staticRenderFns } from "./CardBeatmapsRanked.vue?vue&type=template&id=d3a9b37a&scoped=true&"
import script from "./CardBeatmapsRanked.vue?vue&type=script&lang=js&"
export * from "./CardBeatmapsRanked.vue?vue&type=script&lang=js&"
import style0 from "./CardBeatmapsRanked.vue?vue&type=style&index=0&id=d3a9b37a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a9b37a",
  null
  
)

export default component.exports